//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VocHeaderMenuMobile from "./header-menu-mobile"
import VocMenuItem from "./menuItem.vue"
import mixins from "./mixins"
export default {
  name: "VocHeaderMenuColumn",
  components: {
    VocHeaderMenuMobile,
    VocMenuItem
  },
  mixins: [mixins],
  data() {
    return {
      scrollHandler: null,
      baseStep: [
        {
          type: "system",
          highLight: ".system-selector",
          targetElement: "#systemMenu0",
          position: "left"
        },
        {
          type: "menu",
          highLight: "",
          targetElement: "",
          position: "right"
        }
      ],
      guide: {
        active: false,
        currentStep: 0,
        steps: []
      },
      highLightElement: null // 高亮元素
    }
  },
  watch: {
    guideSteps(newVal) {
      if (!newVal?.length) return
      this.guide.steps = newVal
      this.startGuide()
    }
  },
  computed: {
    guideSteps() {
      if (!this.modules.length) return null
      if (!this.newMenu.length) return null
      return this.guideInfo.guideSteps
        .map(item => {
          const baseStep = this.baseStep.find(step => step.type === item.type)
          let targetElement = ""
          let highLight = ""
          let path = []
          if (item.type === "system") {
            if (this.params.unNeedSysPanel) {
              return null
            }
            const systemIndex = this.modules.findIndex(el => el.title === item.target)
            if (systemIndex === -1) {
              return null
            }
            targetElement = `#systemMenu${systemIndex}`
            highLight = baseStep.highLight
          } else {
            targetElement = `#menu-${item.target}`
            const needOpen = this.getOpenSubMenu(item.target, this.newMenu, [])
            if (!needOpen?.length) return null
            path = needOpen.map(el => el.index)
            highLight = `#menu-${needOpen[0].code}`
          }
          return {
            ...baseStep,
            content: item.content,
            highLight: highLight,
            targetElement: targetElement,
            path: path
          }
        })
        .filter(item => item)
    }
  },
  mounted() {
    const menusEl = this.$el.querySelector(".menus")
    const topEl = this.$el.querySelector(".voc-menu-left-top")

    if (menusEl && topEl) {
      this.scrollHandler = () => {
        if (menusEl.scrollTop > 0) {
          topEl.classList.add("in-scroll")
        } else {
          topEl.classList.remove("in-scroll")
        }
      }
      menusEl.addEventListener("scroll", this.scrollHandler)
    }
    // this.startGuide()
  },
  beforeDestroy() {
    const menusEl = this.$el.querySelector(".menus")
    if (menusEl && this.scrollHandler) {
      menusEl.removeEventListener("scroll", this.scrollHandler)
    }
  },
  methods: {
    handleOverlayClick(event) {
      // 阻止所有可能的事件
      event.preventDefault()
      event.stopPropagation()
      event.stopImmediatePropagation()
    },
    menuClick(item) {
      this.$emit("menuClick", item)
    },

    // 新手引导相关方法
    startGuide() {
      this.guide.active = true
      this.$nextTick(() => {
        this.showCurrentStep()
      })
    },

    showCurrentStep() {
      const step = this.guide.steps[this.guide.currentStep]
      if (step.type === "system") {
        this.$refs.systemSelector?.show()
      } else {
        this.$refs.systemSelector?.hide()
        step.path.forEach(el => {
          this.$refs.columnMenu.openMenu(el)
        })
      }
      setTimeout(() => {
        const highLight = document.querySelector(step.highLight)
        if (highLight) {
          // 高亮当前步骤元素
          if (!this.highLightElement) {
            const newElement = document.createElement("div")
            newElement.classList.add("guide-highlight")
            this.highLightElement = newElement
            document.body.appendChild(newElement)
          }
          const rect = highLight.getBoundingClientRect()

          this.highLightElement.style.width = `${rect.width}px`
          this.highLightElement.style.height = `${rect.height}px`
          this.highLightElement.style.top = `${rect.top}px`
          this.highLightElement.style.left = `${rect.left}px`
          // 计算引导框位置
        }
        const target = document.querySelector(step.targetElement)
        try {
          this.positionGuideBox(target, step.position)
        } catch (error) {
          console.log(error)
        }
      }, 350)
    },

    positionGuideBox(element, position = "right") {
      const rect = element.getBoundingClientRect()
      const guideBox = this.$el.querySelector(".guide-box")

      if (!guideBox || !rect) return
      switch (position) {
        case "top":
          guideBox.style.top = `${rect.top - guideBox.offsetHeight - 20}px`
          guideBox.style.left = `${rect.left - guideBox.offsetWidth / 2}px`
          break
        case "bottom":
          guideBox.style.top = `${rect.bottom + 20}px`
          guideBox.style.left = `${rect.left - guideBox.offsetWidth / 2}px`
          break
        case "left":
          guideBox.style.top = `${rect.top - guideBox.offsetHeight / 2 + 25}px`
          guideBox.style.left = `${rect.left - guideBox.offsetWidth - 40}px`
          break
        case "right":
          guideBox.style.top = `${rect.top - guideBox.offsetHeight / 2 + 25}px`
          guideBox.style.left = `${rect.right + 20}px`
          break
      }
    },

    nextStep() {
      this.guide.currentStep++
      this.showCurrentStep()
    },

    prevStep() {
      this.guide.currentStep--
      this.showCurrentStep()
    },

    clearCurrentStep() {
      document.body.removeChild(this.highLightElement)
    },

    closeGuide() {
      this.guide.active = false
      this.guide.currentStep = 0
      this.$refs.systemSelector?.hide()
      this.guideInfo?.completeCallback()
      try {
        this.clearCurrentStep()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
